import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from '@mui/material';
import { memo, useMemo, useRef } from 'react';
import { ProductTitle } from 'src/features/components/editComponentPage/forms/comboStyle/ComboStyleForm.styled';

import { CategoryConfigItem } from '../categoryConfigItem/CategoryConfigItem';
import { CategoryConfigAccordionProps } from './CategoryConfigAccordion.interface';

const TRANSITION_PROPS = { unmountOnExit: true } as const;

const CategoryConfigAccordionInner = (props: CategoryConfigAccordionProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const titleText = props.variationSizeName || 'None';

  const itemOptions = useMemo(
    () => ({
      hideDisplayLabel: props.options?.hideDisplayLabel,
      showLabelBgColor: true,
      showLabelHeight: true,
      showFlavors: true,
      showDisclaimer: true,
    }),
    [props.options?.hideDisplayLabel],
  );

  return (
    <Accordion
      defaultExpanded={false}
      sx={{ minWidth: 370 }}
      TransitionProps={TRANSITION_PROPS}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        style={{ borderBottom: '1px solid #000' }}>
        <Tooltip
          title={titleText}
          arrow
          disableHoverListener={
            textRef.current
              ? textRef.current.scrollWidth <= textRef.current.clientWidth
              : true
          }>
          <ProductTitle
            ref={textRef}
            style={{
              maxWidth: '300px',
              paddingLeft: '20px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              cursor: 'pointer',
            }}>
            {titleText}
          </ProductTitle>
        </Tooltip>
      </AccordionSummary>
      <AccordionDetails>
        <CategoryConfigItem
          errors={props.errors}
          onChange={props.onChange}
          value={props.value}
          theme={props?.theme}
          variationSizeName={props.variationSizeName}
          options={itemOptions}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export const CategoryConfigAccordion = memo(CategoryConfigAccordionInner);
